<p-dialog
    [header]="draft?._id ? 'Weblink-Kachel bearbeiten' : 'Weblink-Kachel hinzufügen'"
    [visible]="visible"
    (visibleChange)="!$event && close()"
    [modal]="true"
    appendTo="body"
    [style]="{width: '640px', maxWidth: '95vw'}"
    [draggable]="false"
    [resizable]="false"
    [closable]="!saving"
    [closeOnEscape]="!saving"
>
    @if (draft) {
    <form
        #webForm="ngForm"
        (ngSubmit)="save()"
    >
        <fieldset
            [disabled]="saving || loadingMetadata"
            class="border-0 p-0 m-0"
        >
            <div class="mb-3">
                <label
                    class="form-label"
                    for="web-tile-url"
                >Webadresse</label>
                <input
                    id="web-tile-url"
                    name="url"
                    type="url"
                    class="form-control"
                    [(ngModel)]="draft.url"
                    placeholder="https://"
                    required
                    maxlength="2048"
                >
            </div>
            <button
                pButton
                type="button"
                [outlined]="true"
                class="mb-3"
                [loading]="loadingMetadata"
                [disabled]="!validUrl || loadingMetadata || saving"
                (click)="loadMetadata()"
            >
                <i class="ri-download-2-line me-2"></i>Website-Daten übernehmen
            </button>
            <div class="mb-3">
                <label
                    class="form-label"
                    for="web-tile-name"
                >Name</label>
                <input
                    id="web-tile-name"
                    name="name"
                    class="form-control"
                    [(ngModel)]="draft.name"
                    required
                    maxlength="200"
                >
            </div>
            <div class="mb-3">
                <label
                    class="form-label"
                    for="web-tile-description"
                >Beschreibung</label>
                <textarea
                    id="web-tile-description"
                    name="description"
                    class="form-control"
                    [(ngModel)]="draft.subtext"
                    rows="2"
                    maxlength="1000"
                ></textarea>
            </div>
            <div class="d-flex flex-wrap align-items-center gap-3 mb-3">
                <label for="web-tile-color">Akzentfarbe</label>
                <input
                    id="web-tile-color"
                    name="color"
                    type="color"
                    [(ngModel)]="draft.color"
                >
                <button
                    pButton
                    type="button"
                    [outlined]="true"
                    (click)="iconVisible = true"
                    title="Icon auswählen"
                >
                    <i class="ri-image-edit-line me-2"></i>Icon ändern
                </button>
            </div>
            <label class="d-flex align-items-center gap-2 mb-3">
                <input
                    name="newTab"
                    type="checkbox"
                    [(ngModel)]="draft.openInNewTab"
                >In neuem Tab öffnen
            </label>
            <div class="text-muted small mb-2">{{ scope === 'personal' ? 'Nur für dich sichtbar' : scope === 'tenant' ?
                'Freigabe: alle Mitarbeiter dieses Mandanten' :
                'Globaler Kachelkatalog' }}</div>
            @if (scope !== 'personal') {
            <app-tile-image-editor
                [tile]="draft"
                [scope]="scope"
                [active]="visible && !saving"
                (iconClick)="iconVisible = true"
            ></app-tile-image-editor>
            }
        </fieldset>
        @if (error) { <p
            class="text-danger mt-3 mb-0"
            role="alert"
        >{{ error }}</p> }
        <div class="d-flex flex-wrap gap-2 justify-content-end mt-3">
            @if (draft._id && !draft.protected) {
            <button
                pButton
                type="button"
                severity="danger"
                [outlined]="true"
                class="me-auto"
                [disabled]="saving || loadingMetadata"
                (click)="delete()"
            >
                <i class="ri-delete-bin-line me-2"></i>{{ confirmDelete ? 'Löschen bestätigen' : 'Löschen' }}
            </button>
            }
            <button
                pButton
                type="button"
                [outlined]="true"
                [disabled]="saving"
                (click)="close()"
            >Abbrechen</button>
            <button
                pButton
                type="submit"
                [loading]="saving"
                [disabled]="!webForm.valid || !validUrl || saving || loadingMetadata"
            >
                <i class="ri-save-line me-2"></i>Speichern
            </button>
        </div>
    </form>
    }
</p-dialog>
<app-tile-icon-picker
    [(visible)]="iconVisible"
    [color]="draft?.color ?? '#004f9f'"
    (accepted)="chooseIcon($event)"
></app-tile-icon-picker>